import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Template, TemplateHero, TemplateContent, TemplateAvatar, ReducedTemplateHero } from './TrelloTemplate.styles';
import { useAnalytics } from '../../../components';
import { getColorsFromBackgroundField } from '../../../styles';
export function TrelloTemplate({ disabled, model: { id, content }, reduced }) {
    const { sendTrackEvent } = useAnalytics();
    const { attribution, avatar, avatarPadding, backgroundImage, description, title } = content;
    return (_jsxs(Template, Object.assign({ "data-testid": "individual-template", "data-uuid": id, draggable: "false", href: content.url, onClick: (e) => {
            if (disabled) {
                e.preventDefault();
                return;
            }
            sendTrackEvent('clickedLinkInGallery', {
                event: 'clicked',
                eventComponent: 'link',
                eventContainer: 'gallery',
                href: content.url,
                label: content.title,
                labelEnglish: content.entryTitle,
                uuid: id
            });
        } }, { children: [reduced ? (_jsx(ReducedTemplateHero, Object.assign({ image: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.content.image.url }, getColorsFromBackgroundField(content.background)), void 0)) : (_jsx(TemplateHero, Object.assign({ image: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.content.image.url }, getColorsFromBackgroundField(content.background)), void 0)), _jsxs(TemplateContent, { children: [_jsx(TemplateAvatar, { image: avatar, padding: avatarPadding }, void 0), _jsx("h3", { children: title }, void 0), attribution && _jsx("p", Object.assign({ className: "muted" }, { children: attribution }), void 0), _jsx("p", { children: description }, void 0)] }, void 0)] }), void 0));
}
//# sourceMappingURL=TrelloTemplate.js.map